export const KEYWORD_ALLOWLIST = "allow";
export const KEYWORD_BLOCKLIST = "block";

export const PATTERN_ALLOWLIST = `[${KEYWORD_ALLOWLIST}:`;
export const PATTERN_BLOCKLIST = `[${KEYWORD_BLOCKLIST}:`;
